export const DEFAULT = 'DEFAULT';
export const MY_FARM = 'MY_FARM';
export const DEMO_FARM = 'DEMO_FARM';
export const REAL_TIME = 'REAL_TIME';
